var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6844 0H6.57801C5.85816 0 5.26241 0.595745 5.26241 1.3156V5.23759H1.3156C0.595745 5.23759 0 5.83333 0 6.55319V19.6596C0 20.3794 0.595745 20.9752 1.3156 20.9752H14.422C15.1418 20.9752 15.7376 20.3794 15.7376 19.6596V15.7128H19.6844C20.4043 15.7128 21 15.117 21 14.3972V1.29078C20.9752 0.570922 20.4043 0 19.6844 0ZM13.7766 18.9894H1.98582V7.19858H5.26241V14.3972C5.26241 15.117 5.85816 15.7128 6.57801 15.7128H13.7766V18.9894ZM19.0142 13.7518H7.2234V1.96099H19.0142V13.7518Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeCopy);
export default __webpack_public_path__ + "static/media/code-copy.7e75288cb3c30fbd4a75a09a4e0692b4.svg";
export { ForwardRef as ReactComponent };